// extracted by mini-css-extract-plugin
module.exports = {"belleitem":"item_belleitem_3Onev","right":"item_right_2jllW","title":"item_title_3dztX","tags":"item_tags_1NoGD"};